// extracted by mini-css-extract-plugin
export default {"content":"masterLayout_content__1WrP0"};